export default __webpack_public_path__ + "static/media/30-need.43e8baac.png";